<template>
  <div class="two-factor__form-wrapper">
    <form @submit.prevent="validateFields" class="two-factor__form">
      <div class="two-factor__title-wrapper">
        <h2 class="two-factor__title">Enter your 6-digit MFA code</h2>
        <h5 class="two-factor__tagline">SMS, email, or Google Authenticator</h5>
      </div>
    </form>
    <DigitCodeInput @handle-success-form="handleSuccessForm" />
    <div v-show="!isLoadingCaptcha" class="two-factor__additional-links">
      <button
        @click.prevent="$emit('resend-mfa-code')"
        class="two-factor__additional-link"
        v-if="canResendMFACode"
      >
        Resend Code
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { validateForm, clearFormErrors } from '@/helpers'
import DigitCodeInput from '@/components/login/two-factor/DigitCodeInput.vue'

export default {
  name: 'TwoFactorForm',
  components: {
    DigitCodeInput,
  },
  data() {
    return {
      errors: clearFormErrors(),
      fields: {
        'mfa code': {
          type: 'text',
          rules: ['presence'],
          placeholder: 'MFA Code',
          value: '',
          autocomplete: 'one-time-code',
        },
      },
    }
  },
  computed: {
    ...mapState({
      isLoadingCaptcha: state => state.app.isLoadingCaptcha,
    }),
    canResendMFACode() {
      return !this.$store.state.auth.userProfile?.mfa_method === 'google_auth'
    },
  },
  methods: {
    validateFields() {
      const { fields } = this
      const { isValid, errors } = validateForm(fields)
      this.errors = errors
      if (isValid) {
        const payload = {
          code: fields['mfa code'].value,
        }
        this.$emit('submit-form', payload)
      }
    },
    clearErrors() {
      this.errors = clearFormErrors()
    },
    async handleSuccessForm() {
      await this.$store.dispatch('auth/handleLoginSuccess')
    },
  },
}
</script>

<style lang="scss">
.two-factor {
  &__aside {
    padding: 40px !important;
  }
  &__form-wrapper {
    display: flex;
    flex-direction: column;
  }
  &__form {
    font-family: 'CircularStd-Book';
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__title {
    font-size: rem(24);
    line-height: 32px;
    margin: 0 0 10px 0;
    color: var(--white);
  }
  &__tagline {
    font-size: rem(18);
    line-height: 24px;
    margin: 0 0 30px 0;
    color: var(--light-blue-gray);
    text-align: center;
  }
  &__additional-links {
    position: absolute;
    bottom: 0;
    left: 0;
  }
  &__additional-link {
    font-family: var(--font-regular);
    color: var(--light-blue-gray);
    font-size: rem(12);
    border: none;
    background: none;
    cursor: pointer;
    &:hover {
      font-family: var(--font-bold);
    }
  }
}
</style>
